import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    alignItems: 'flex-start',
  },
  chatIcon: {
    mt: '4px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
